import API from '../../sunwiseAPI';

const config = { headers: { 'Content-Type': 'application/json' } };
const ENTITY = 'period-reporter';

export const getData = (uuid) => API.get(`/api/v1/${ENTITY}/${uuid}/sunpay`);
export const saveData = (uuid, data) =>
    API.post(`/api/v1/${ENTITY}/${uuid}/sunpay`, data, config);
